/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {FC, useEffect, useState, useMemo} from 'react'
import {TabLavanderiaModel} from '../../../../../../models'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {InspectModel, SelectModel} from '../../../../model'
import {getInspect} from '../../../../services'
import {getCompany, getClient, getSite, getMasterService} from '../../../../../central/services'
import {CompanyModel, ClientModel, SiteModel} from '../../../../../central/model'
import {useKhipu} from '../../../../../../hooks/useKhipu'
interface FormattedDate {
  fecha: string
  tiempo: string
}
const TableInspect: FC = () => {
  const {
    data,
    setData,
    loading,
    setLoading,
    clearSelected,
    pagination,
    updateTable,
    setUpdateTable,
    selectedOn,
    clearTable,
    setClearTable,
  } = useKTable()
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useLavanderia()
  const {searchValues, changeSearchValues, clearSearchValues} = useKhipu()

  const [company, setCompany] = useState<SelectModel[]>([])
  const [client, setClient] = useState<SelectModel[]>([])
  const [site, setSite] = useState<SelectModel[]>([])
  const [typeInspect, setTypeInspect] = useState<SelectModel[]>([])
  const [inspectScope, setInspectScope] = useState<SelectModel[]>([])
  const [typeAdmin, setTypeAdmin] = useState<SelectModel[]>([])

  const getFormatDate = (fechaIn: any): FormattedDate | string => {
    if (!fechaIn) {
      return ''
    }
    let fechaActual = new Date(fechaIn)
    let año: Date | any = fechaActual.getFullYear()
    let mes: Date | any = fechaActual.getMonth() + 1
    let dia: Date | any = fechaActual.getDate()
    let hora: Date | any = fechaActual.getHours()
    let minutos: Date | any = fechaActual.getMinutes()
    let segundos: Date | any = fechaActual.getSeconds()

    // Formatear la salida si es necesario
    mes = mes < 10 ? '0' + mes : mes
    dia = dia < 10 ? '0' + dia : dia
    hora = hora < 10 ? '0' + hora : hora
    minutos = minutos < 10 ? '0' + minutos : minutos
    segundos = segundos < 10 ? '0' + segundos : segundos

    // Imprimir la fecha y hora
    return {fecha: dia + '/' + mes + '/' + año, tiempo: hora + ':' + minutos + ':' + segundos}
  }
  const getCompanyList = async () => {
    let obj: CompanyModel = {
      isCombo: true,
    }
    const response = await getCompany(obj, pagination.currentPage)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombreEmpresa}))
    setCompany(mappedSites)
  }
  const getClientList = async (id: any) => {
    let obj: ClientModel = {
      isCombo: true,
      companiaId: id,
    }
    const response = await getClient(obj, pagination.currentPage)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombreEmpresa}))
    setClient(mappedSites)
  }
  const getSiteList = async (id: any) => {
    let obj: SiteModel = {
      isCombo: true,
      clienteId: id,
    }
    const response = await getSite(obj, pagination.currentPage)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
    setSite(mappedSites)
  }

  const getInspectionScopeList = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'AlcanceInspeccion',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.codigo,
        label: master.nombreCorto,
      }))

      setInspectScope(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }
  const getTypeReceptionList = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoInspeccion',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.codigo,
        label: master.nombreCorto,
      }))

      setTypeInspect(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }
  const getTypeAdminList = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoAdministracion',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.codigo,
        label: master.nombreCorto,
      }))

      setTypeAdmin(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }
  const meetsStandar = [
    {
      value: 'SI',
      label: 'SI',
    },
    {
      value: 'NO',
      label: 'NO',
    },
  ]
  const getInspectList = async () => {
    setLoading(true)
    let obj = searchValues
    if (Object.values(obj).length > 0) {
      let value = obj.cumpleEstandar === 'SI' ? true : false
      obj = {...obj, cumpleEstandar: value}
    }

    const response = await getInspect(obj, pagination.currentPage)
    const dataInfo = response.data?.data || []
    if (dataInfo.length > 0) {
      dataInfo.forEach((objeto) => {
        let dateCreation = objeto.fechaProgramacion ? getFormatDate(objeto.fechaProgramacion) : ''
        objeto.fechaProgramacion = dateCreation ? (dateCreation as FormattedDate).fecha : ''
        let dateExecute = objeto.fechaEjecutada ? getFormatDate(objeto.fechaEjecutada) : ''
        objeto.fechaEjecutada = dateExecute ? (dateExecute as FormattedDate).fecha : ''
        objeto.cumpleEstandar = objeto.cumpleEstandar ? 'SI' : 'NO'
        return objeto
      })
    }

    setData(dataInfo)
    setLoading(false)
  }

  useEffect(() => {
    getCompanyList()
    getTypeAdminList()
    getTypeReceptionList()
    getInspectionScopeList()
    return () => {
      clearSearchValues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    getInspectList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  const handleViewPanel = (data: any) => {
    const getRow = data.row
    const getArrows = data.data
    const getData = getArrows[getRow.index]
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      showPanel: true,
      idToEdit: getData.id,
      content: {
        ...currentTabItem.content,
        detailPanel: 'tab-inspect',
      },
      idToDelete: '',
    }
    changeCurrentTabItem(obj)
    clearSelected()
  }

  const handleGetId = (id: any) => {
    let idChange = id === currentTabItem.idToDelete ? '' : id
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      showPanel: false,
      idToDelete: idChange,
      idToEdit: '',
    }
    changeCurrentTabItem(obj)
  }

  const handleFilterClient = (e: any, name: string) => {
    let value = e.value
    getClientList(value)
    const {ClienteId, SiteId, CampamentoId, ...valuesSearch} = searchValues
    const nuevoObjeto = {...valuesSearch, [name]: value}
    changeSearchValues(nuevoObjeto)
  }

  const handleFilterSite = (e: any, name: string) => {
    let value = e.value
    getSiteList(value)
    const {SiteId, CampamentoId, ...valuesSearch} = searchValues
    const nuevoObjeto = {...valuesSearch, [name]: value}
    changeSearchValues(nuevoObjeto)
  }
  const handleFilterStandar = (e: any, name: string) => {
    let value = e.value
    const {SiteId, CampamentoId, ...valuesSearch} = searchValues
    const nuevoObjeto = {...valuesSearch, [name]: value}
    changeSearchValues(nuevoObjeto)
  }
  const columns: Column<InspectModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} showSelect={false} />,
        id: 'selection',
        Cell: ({...props}) => (
          <KTableSelectionCellNonMultiple
            id={props.data[props.row.index].id}
            clickHandler={handleGetId}
          />
        ),
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Compañía'
            name='companiaId'
            data={company}
            selecteable
            onGetValueSelect={handleFilterClient}
          />
        ),
        accessor: 'compania',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cliente'
            name='clienteId'
            data={client}
            selecteable
            onGetValueSelect={handleFilterSite}
          />
        ),
        accessor: 'cliente',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Site' name='siteId' data={site} selecteable />
        ),
        accessor: 'site',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Código de inspección'
            name='codigoInspeccion'
            searcheable
          />
        ),
        accessor: 'codigoInspeccion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo de inspección'
            name='tipoInspeccion'
            data={typeInspect}
            selecteable
          />
        ),
        accessor: 'tipoInspeccionNombre',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha programada'
            name='fechaProgramacion'
            dateable
          />
        ),
        accessor: 'fechaProgramacion',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Fecha ejecutada' name='fechaEjecutada' dateable />
        ),
        accessor: 'fechaEjecutada',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Porcentaje obtenido'
            name='porcentaje'
            searcheable
          />
        ),
        accessor: 'porcentaje',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cumple estándar'
            name='cumpleEstandar'
            data={meetsStandar}
            selecteable
            onGetValueSelect={handleFilterStandar}
          />
        ),
        accessor: 'cumpleEstandar',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Alcance de inspección'
            name='alcanceInspeccion'
            data={inspectScope}
            selecteable
          />
        ),
        accessor: 'alcanceInspeccionNombre',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo de administración'
            name='tipoAdministracion'
            data={typeAdmin}
            selecteable
          />
        ),
        accessor: 'tipoAdministracion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Estado'
            name='estado'
            data={typeInspect}
            selecteable
          />
        ),
        accessor: 'estado',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions',
        Cell: ({...props}) => (
          <>
            {isAllowed('EDITAR') && (
              <div
                className='d-flex justify-content-center flex-shrink-0'
                onClick={() => handleViewPanel(props)}
              >
                <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                  <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
                </a>
              </div>
            )}
          </>
        ),
      },
    ],
    [company, client, site, typeAdmin, typeInspect, selectedOn],
  )

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  useEffect(() => {}, [data])

  useEffect(() => {
    if (updateTable) {
      clearSelected()
      getInspectList()
      setUpdateTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTable])
  useEffect(() => {
    if (clearTable) {
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])
  return (
    <>
      {isAllowed('LISTAR') && (
        <KTCard shadow className='mx-2  w-100'>
          <KTable data={data} columns={columns} />
          {loading ? <KTableLoading title='Cargando...' /> : null}
        </KTCard>
      )}
    </>
  )
}

const TableInspectWrapper = () => {
  return (
    <KTableProvider>
      <TableInspect />
    </KTableProvider>
  )
}

export {TableInspectWrapper}
